module.exports = __webpack_public_path__ + "static/media/danthabhagya5.f65e8894.jpg";